import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Modal from "../../modal/Modal";
import { alertError, alertInfo, toastInfo, toastError, confirm } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import { focusChannel, openChannel } from "actions/ui";
import { closeChannel } from "actions/ui";
import { removeChannel } from "actions/application";
import { refreshChannel } from "actions/application";
import {Scrollbar} from "react-scrollbars-custom";
import NotifyUsers from "./components/NotifyUsers";
import ChannelOptions from "./components/ChannelOptions";

class ChannelEdit extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.state = {
			tab: 'basic',
			modalOpen: false,
			...this.getCleanState(),
			addRequests: []
		}

		this.handleAdd = this.handleAdd.bind(this);
		this.openModal = this.openModal.bind(this);
		this.hideModal = this.hideModal.bind(this);
		this.deleteFromChannel = this.deleteFromChannel.bind(this);
		this.searchUsers = this.searchUsers.bind(this);
		this.renderMemberResult = this.renderMemberResult.bind(this);
		this.deleteChannel = this.deleteChannel.bind(this);
	}

	switchTab(e, tab) {
		e.preventDefault();
		this.setState({tab: tab});
	}

	getCleanState() {
		return {
			name: this.props.channel.name,
			type: this.props.channel.type,
			configuration: this.props.channel.configuration,
			invalidName: false,
			invalidType: false,
			newMember: ''
		}
	}

	handleAdd() {
		if (this.validate()) {
			this.props.sendUserCommand('saveChannel', 'saveChannel', { id: this.props.channel.id, name: this.state.name, type: this.state.type, configuration: JSON.stringify(this.state.configuration) });
		}
	}

	validate() {
		let valid = true;

		if (!this.state.name) {
			this.setState( { invalidName: true } );
			valid = false;
		}
		if (!this.state.type) {
			this.setState( { invalidType: true } );
			valid = false;
		}

		return valid;
	}

	openModal(e) {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ modalOpen: true, ...this.getCleanState() });

		this.props.sendUserCommand('getChannelMembers', 'getChannelMembers', { id: this.props.channel.id });
	}

	hideModal() {
		this.props.clearUserCommand('getChannelMembers');
		this.setState({ modalOpen: false });
	}

	componentDidUpdate(prevProps) {
		const commandFailure = this.props.command !== prevProps.command && this.props.command && this.props.command.success === false;
		const commandSuccess = this.props.command !== prevProps.command && this.props.command && this.props.command.success === true;
		const deleteFailure = this.props.deleteMember !== prevProps.deleteMember && this.props.deleteMember && this.props.deleteMember.success === false;
		const deleteSuccess = this.props.deleteMember !== prevProps.deleteMember && this.props.deleteMember && this.props.deleteMember.success === true;
		const deleteChannelFailure = this.props.deleteChannel !== prevProps.deleteChannel && this.props.deleteChannel && this.props.deleteChannel.success === false;
		const deleteChannelSuccess = this.props.deleteChannel !== prevProps.deleteChannel && this.props.deleteChannel && this.props.deleteChannel.success === true;
		const addFailure = this.props.inviteChannelMember !== prevProps.inviteChannelMember && this.props.inviteChannelMember && this.props.inviteChannelMember.success === false;
		const addSuccess = this.props.inviteChannelMember !== prevProps.inviteChannelMember && this.props.inviteChannelMember && this.props.inviteChannelMember.success === true;

		if (commandFailure) {
			this.props.alertError(this.props.command.error);
			this.props.clearUserCommand('saveChannel');
		}

		if (commandSuccess) {
			const channel = this.props.command.result.channel;

			if (channel.id === this.props.channel.id) {
				this.setState({modalOpen: false});
				this.props.clearUserCommand('saveChannel');

				this.props.refreshChannel(channel);
				this.props.toastInfo(this.props.i18n.channelSaved);
			}
		}

		if (deleteFailure) {
			this.props.alertError(this.props.deleteMember.error);
			this.props.clearUserCommand('deleteChannelMember');
		}

		if (deleteSuccess) {
			const channel = this.props.deleteMember.result.channel;

			if (channel.id === this.props.channel.id) {
				this.props.clearUserCommand('deleteChannelMember');

				this.props.sendUserCommand('getChannelMembers', 'getChannelMembers', { id: this.props.channel.id });
				this.props.toastInfo(this.props.i18n.memberRemoved);
				this.setState( state => ({ addRequests: [ ] }));
			}
		}

		if (addFailure) {
			this.props.alertError(this.props.inviteChannelMember.error);
			this.props.clearUserCommand('inviteChannelMember');
		}
		if (addSuccess) {
			const channel = this.props.inviteChannelMember.result.channel;

			if (channel.id === this.props.channel.id) {
				this.props.clearUserCommand('inviteChannelMember');
				this.props.sendUserCommand('getChannelMembers', 'getChannelMembers', { id: this.props.channel.id });
				this.props.toastInfo(this.props.i18n.invitationSent);
				this.setState( state => ({ addRequests: [ ...state.addRequests, this.props.inviteChannelMember.result.parameters.userId ] }));
			}
		}

		if (deleteChannelFailure) {
			this.props.alertError(this.props.deleteChannel.error);
			this.props.clearUserCommand('deleteChannel');
		}
		if (deleteChannelSuccess) {
			const channelId = this.props.deleteChannel.result.channelId;
			if (channelId === this.props.channel.id) {
				this.props.closeChannel(channelId);
				this.props.removeChannel(channelId);
				this.props.clearUserCommand('deleteChannel');
				this.props.toastInfo(this.props.i18n.channelDeleted);
			}
		}
	}

	componentWillUnmount() {
		this.props.clearUserCommand('getChannelMembers');
		if (this.usersSearchTimer) {
			clearTimeout(this.usersSearchTimer);
			this.usersSearchTimer = null;
		}
	}

	deleteFromChannel(e, member) {
		e.preventDefault();

		this.props.confirm(this.props.i18n.askRemoveMember, function() {
			this.props.sendUserCommand('deleteChannelMember', 'deleteChannelMember', { channelId: this.props.channel.id, memberId: member.id });
		}.bind(this));
	}

	inviteToChannel(e, user) {
		e.preventDefault();

		this.props.confirm(this.props.i18n.askJoin, function() {
			this.props.sendUserCommand('inviteChannelMember', 'inviteChannelMember', { channelId: this.props.channel.id, wpUserId: user.id });
		}.bind(this));
	}

	deleteChannel() {
		this.props.confirm(this.props.i18n.askDeleteChannel, function() {
			this.props.sendUserCommand('deleteChannel', 'deleteChannel', { channelId: this.props.channel.id });
		}.bind(this));
	}

	searchUsers() {
		if (this.usersSearchTimer) {
			clearTimeout(this.usersSearchTimer);
			this.usersSearchTimer = null;
		}
		if (this.state.newMember) {
			this.usersSearchTimer = setTimeout(function() { this.searchUsersReal(); }.bind(this), 400);
		}
	}

	searchUsersReal() {
		this.props.sendUserCommand('searchUsers', 'searchUsers', { search: this.state.newMember });
	}

	renderMemberResult(member, index) {
		return <tr key={ index }>
			<td>
				<div className="wcFlex wcFlexAlignCenter">
					<img src={member.avatarUrl} className="wcMaxWidth2 wcFunctional" alt="Member picture"/>&nbsp;<span>{member.name}</span>
				</div>
			</td>
			<td>{member.type}</td>
			<td>{ member.confirmed ? this.props.i18n.confirmed : this.props.i18n.awaiting }</td>
			<td><a href="#" className="wcFunctional" title={ this.props.i18n.deleteFromChannel } onClick={ e => this.deleteFromChannel(e, member) }><span className="wcIcon wcIconX" /></a></td>
		</tr>
	}

	render() {
		if (!this.props.channel.canEdit) {
			return null;
		}

		return <React.Fragment>
			<span className="wcChannelEditButton wcIcon wcIconEdit" title={ this.props.i18n.editChannel } onClick={ this.openModal } />
			<Modal
				open={ this.state.modalOpen }
				onClose={ this.hideModal }
				title={ this.props.i18n.editChannel }
				size="lg"
				footer={ [
					<button key="save" className="wcButton" onClick={ this.handleAdd } disabled={ this.props.command && this.props.command.inProgress }>{ this.props.i18n.save }</button>
				] }
				closable={ !(this.props.command && this.props.command.inProgress) }
				closeOnDocumentClick={ false }
			>
				<ul className="wcPrimaryTabs">
					<li className="wcPrimaryTabItem">
						<a className={ `wcPrimaryTabLink ${ this.state.tab === 'basic' ? 'wcPrimaryTabItemActive' : '' }` } onClick={ e => this.switchTab(e, 'basic') } href="#">{ this.props.i18n.basic }</a>
					</li>
					<li className="wcPrimaryTabItem">
						<a className={ `wcPrimaryTabLink ${ this.state.tab === 'participants' ? 'wcPrimaryTabItemActive' : '' }` } onClick={ e => this.switchTab(e, 'participants') } href="#">{ this.props.i18n.participants }</a>
					</li>
					<li className="wcPrimaryTabItem">
						<a className={ `wcPrimaryTabLink ${ this.state.tab === 'options' ? 'wcPrimaryTabItemActive' : '' }` } onClick={ e => this.switchTab(e, 'options') } href="#">Options</a>
					</li>
					<li className="wcPrimaryTabItem">
						<a className={ `wcPrimaryTabLink ${ this.state.tab === 'advanced' ? 'wcPrimaryTabItemActive' : '' }` } onClick={ e => this.switchTab(e, 'advanced') } href="#">{ this.props.i18n.advanced }</a>
					</li>
				</ul>

				{ this.state.tab === 'basic' &&
					<React.Fragment>
						<div className="wcFormRow">
							<label>{ this.props.i18n.name }: </label>
							<input
								className={ `wcFormControl ${ this.state.invalidName ? ' wcFormError' : ''}` }
								type="text"
								maxLength={ 200 }
								value={ this.state.name }
								onChange={ e => this.setState({ name: e.target.value, invalidName: false })}
							/>
							<div className="wcFormErrorMessage">{ this.props.i18n.enterChannelName }</div>
						</div>

						<div className="wcFormRow">
							<input
								className={ `wcFormCheck ${ this.state.invalidType ? ' wcFormError' : ''}` }
								type="radio"
								checked={ this.state.type === 'private' }
								value="private"
								onChange={ e => this.setState({ type: e.target.value, invalidType: false })}
								name="flexRadioDefault"
								id="type1"
							/>
							<label className="wcFormCheckLabel" htmlFor="type1">
								{ this.props.i18n.privateChannel }
							</label>
							<input
								className={ `wcFormCheck ${ this.state.invalidType ? ' wcFormError' : ''}` }
								type="radio"
								checked={ this.state.type === 'public' }
								value="public"
								onChange={ e => this.setState({ type: e.target.value, invalidType: false })}
								name="flexRadioDefault"
								id="type2"
							/>
							<label className="wcFormCheckLabel" htmlFor="type2">
								{ this.props.i18n.publicChannel }
							</label>
							<div className="wcFormErrorMessage">{ this.props.i18n.selectChannelType }</div>
						</div>
						{ this.state.type &&
							<div className="wcFormRow">
								{ this.state.type === 'public' && this.props.i18n.hintPublic }
								{ this.state.type === 'private' && this.props.i18n.hintPrivate }
							</div>
						}
					</React.Fragment>
				}
				{ this.state.tab === 'participants' &&
					<React.Fragment>
						{ this.state.type === 'public' && <NotifyUsers channel={ this.props.channel } /> }
						{this.state.type === 'private' && <React.Fragment>
							<div className="wcFormRow">
								<label>{ this.props.i18n.inviteUser }: </label>
								<input
									className={ `wcFormControl` }
									type="text"
									maxLength={ 200 }
									value={ this.state.newMember }
									onChange={ e => this.setState({ newMember: e.target.value }, this.searchUsers )}
								/>
							</div>
							{ this.state.newMember &&
								<div className="wcFormRow">
									<label>{ this.props.i18n.foundUsers }: </label>
									<div className="wcFormControlBorder wcHeight10 wcPadding1">
										{this.props.users && this.props.users.inProgress && <span className="wcMargin1">{ this.props.i18n.searching }</span> }
										{this.props.users && !this.props.users.inProgress && this.props.users.result.users.length === 0 && <span className="wcMargin1">{ this.props.i18n.noUsers }</span> }
										{this.props.users && this.props.users.result &&
											<Scrollbar>
												{this.props.users.result.users.map( (user, index) => <div
													key={ index }
													className="wcFlex wcFlexAlignCenter wcMargin1">
													<img src={user.avatarUrl} className="wcMaxWidth2 wcFunctional" alt="Member picture"/>&nbsp;<span>{user.name}</span>&nbsp;
													{ !this.state.addRequests.includes(user.id) &&
														<a href="#" className="wcFunctional" title={ this.props.i18n.inviteToJoin } onClick={ e => this.inviteToChannel(e, user) }><span className="wcIcon wcIconPlus" /></a>
													}
												</div>)}
											</Scrollbar>
										}
									</div>
								</div>
							}
							<div className="wcFormRow">
								<label>{ this.props.i18n.channelMembers }: </label>
								<div className="wcFormControlBorder wcHeight10 wcPadding1">
									{this.props.members && this.props.members.inProgress && <span className="wcMargin1">{ this.props.i18nBase.loading }</span> }
									{this.props.members && this.props.members.result &&
										<Scrollbar>
											<table className="wcTable">
												<thead>
													<tr>
														<th>{ this.props.i18n.memberName }</th>
														<th>{ this.props.i18n.memberType }</th>
														<th>{ this.props.i18n.memberStatus }</th>
														<th>{ this.props.i18n.memberActions }</th>
													</tr>
												</thead>
												<tbody>
													{this.props.members.result.members.map( (entry, index) => this.renderMemberResult(entry, index) )}
												</tbody>
											</table>
										</Scrollbar>
									}
								</div>
							</div>
						</React.Fragment>
						}
					</React.Fragment>
				}
				{ this.state.tab === 'options' && <ChannelOptions
					channel={ this.props.channel }
					configuration={ this.state.configuration }
					onConfigurationChange={ change => this.setState(state => ({ configuration: { ...state.configuration, ...change } })) } />
				}
				{ this.state.tab === 'advanced' &&
					<div className="wcFormRow">
						<button className="wcButton wcButtonDanger" onClick={ this.deleteChannel }>{ this.props.i18n.deleteChannel }</button>
						<br />
						{ this.props.i18n.warningDelete }
					</div>
				}
			</Modal>
		</React.Fragment>
	}

}

ChannelEdit.propTypes = {
	configuration: PropTypes.object.isRequired,
	channel: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18nBase: state.configuration.i18n,
		i18n: state.application.i18n,
		command: state.commands.sent.saveChannel,
		members: state.commands.sent.getChannelMembers,
		users: state.commands.sent.searchUsers,
		deleteMember: state.commands.sent.deleteChannelMember,
		inviteChannelMember: state.commands.sent.inviteChannelMember,
		deleteChannel: state.commands.sent.deleteChannel
	}),
	{ sendUserCommand, clearUserCommand, alertError, alertInfo, focusChannel, openChannel, refreshChannel, toastInfo, toastError, confirm, closeChannel, removeChannel }
)(ChannelEdit);